module.exports = __webpack_public_path__ + "img/F2g.e9f31ac3.svg";